import React, { useState, useEffect } from "react";
import { useHistory, Link } from "react-router-dom";
import { useToasts } from 'react-toast-notifications';
import { makeStyles } from "@material-ui/core/styles";

import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import ClipLoader from "react-spinners/ClipLoader";

import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Button from "components/CustomButtons/Button.js";

import api from '../../services/api';
import format from "../../services/Format";

const styles = {
  iconInputLogin: {
    fontSize: 22,
    color: '#bbbbbb',
    marginTop: -2,
    marginLeft: 16
  },

  iconInputLoginEye: {
    fontSize: 22,
    color: '#bbbbbb',
    marginTop: -2,
    cursor: 'pointer',
    marginRight: 16
  },

  margin: {
    height: 50
  },

  cardTitleWhite: {
    fontSize: '31px',
    color: "#1989FF",
    textAlign: 'center'
  },

  gridContainer: {
    height: '100vh',
    width: '100%',
    marginTop: '-70px'
  },
};

const useStyles = makeStyles(styles);

export default function SignIn() {
  const classes = useStyles();
  const history = useHistory();
  const { addToast } = useToasts();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = React.useState(false);
  const [type, setType] = React.useState("password");
  const [connected, setConnected] = React.useState(true);

  useEffect(() => {
    let token = localStorage.getItem('token');
    if (token && connected) {
      history.push("/registrar");
    } else {
      localStorage.clear();
      history.push("/");
    }
  }, [connected, history]);

  const handleSignIn = async () => {
    setLoading(true);
    if (!email || !password) {
      setLoading(false);
      addToast("Por favor, informe o CPF e a Senha!", { appearance: 'error' });
    } else {
      try {
        let formatCpf = email.replace(/[./-]+/g, "");
        let res = await api.auth(formatCpf, password);
        if (res.data) {
          let token = res.data.token;
          localStorage.setItem('token', token);
          localStorage.setItem('cpf', formatCpf);
          localStorage.setItem('connected', connected);
          setLoading(false);
          history.push("/registrar");
        } else {
          setLoading(false);
          addToast("Não foi possível efetuar o login: Tente novamente em alguns instantes!", { appearance: 'error' });
        }
      } catch (err) {
        setLoading(false);
        if (err.message) {
          addToast(`Não foi possível efetuar o login: ${err.message}`, { appearance: 'error' });
        }
      }
    }
  };

  const onVisible = () => {
    if (visible) {
      setVisible(false);
      setType("password");
    } else {
      setVisible(true);
      setType("text");
    }
  }

  const handleChange = (event) => {
    setConnected(event.target.checked);
    localStorage.setItem('connected', event.target.checked);
  };

  return (
    <div style={{ justifyContent: 'center', textAlign: 'center', alignItems: 'center', width: '100%', height: '100%' }}>
      <GridContainer style={{ justifyContent: 'center', alignItems: 'center', height: '100%', zIndex: 1 }} >
        <GridItem>
          <Card style={{
            backgroundColor: '#f8f9fd',
            borderRadius: 25,
            borderBottomLeftRadius: 25,
            borderBottomRightRadius: 25,
            borderTopLeftRadius: 25,
            borderTopRightRadius: 25,
            borderColor: '#C8C8C8',
            height: '380px',
            width: '380px',
            boxShadow: '0 1px 4px 0 rgb(0 0 0 / 40%)'
          }}>
            <CardHeader style={{ height: '30px', marginTop: 20, marginBottom: 10 }}>
              <h4 className={classes.cardTitleWhite} style={{
                lineHeight: '20px',
                fontWeight: 400,
                color: '#1989ff',
                fontSize: 42
              }}>Olá!</h4>
            </CardHeader>

            <CardBody style={{ padding: 0 }}>
              <GridItem xs={12} sm={12} md={12}>
                <FormControl xs={12} sm={12} md={12} style={{ marginTop: 30 }}>
                  <Input xs={12} sm={12} md={12}
                    style={{ width: 250 }}
                    autoFocus={false}
                    disableUnderline
                    placeholder="CPF"
                    inputProps={{
                      value: email,
                      onChange: (event) => {
                        setEmail(format.cpfMask(event.target.value));
                      },
                    }}
                    startAdornment={
                      <InputAdornment position="start">
                        <i className="icon-single-neutral" style={styles.iconInputLogin} />
                      </InputAdornment>
                    }
                  />
                </FormControl>

                <FormControl xs={12} sm={12} md={12} className={classes.margin} style={{ marginTop: 10 }}>
                  <Input xs={12} sm={12} md={12}
                    style={{ width: 250 }}
                    autoFocus={false}
                    disableUnderline
                    placeholder="Senha"
                    inputProps={{
                      value: password,
                      onChange: (event) => { setPassword(event.target.value) },
                      type: type,
                      onKeyDown: (e) => {
                        if (e.key === 'Enter') {
                          handleSignIn();
                        }
                      }
                    }}
                    startAdornment={
                      <InputAdornment position="start">
                        <i className="icon-lock-1" style={styles.iconInputLogin} />
                      </InputAdornment>
                    }
                    endAdornment={
                      visible ?
                        <InputAdornment position="end">
                          <i className="icon-eye-off" style={styles.iconInputLoginEye} onClick={() => onVisible()} />
                          {/* <Visibility onClick={() => onVisible() } /> */}
                        </InputAdornment>
                        :
                        <InputAdornment position="end">
                          <i className="icon-eye" style={styles.iconInputLoginEye} onClick={() => onVisible()} />
                          {/* <VisibilityOff onClick={() => onVisible()} /> */}
                        </InputAdornment>
                    }
                  />
                </FormControl>

                <FormControlLabel
                  style={{ marginTop: 15 }}
                  value="end"
                  control={<Checkbox color="primary" onChange={handleChange} checked={connected} />}
                  label="Continuar Conectado"
                  labelPlacement="end"
                />
              </GridItem>
            </CardBody>

            <CardFooter style={{ justifyContent: 'center', alignItems: 'baseline', height: '100px', display: 'grid', padding: 0 }}>
              <Button style={{ borderRadius: '25px', width: 180 }} onClick={() => handleSignIn()} color="primary" disabled={loading}>Acessar</Button>
              <Link style={{ marginBottom: 5, color: '#1989ff', fontWeight: 500 }} to="/recuperarsenha/solicitar">Esqueci Minha Senha</Link>
            </CardFooter>

            <div style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}>
              <ClipLoader
                size={80}
                color={"#364e6b"}
                loading={loading}
                css={{ border: '8px solid', borderBottomColor: 'transparent' }}
              />
            </div>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}
